import { render, staticRenderFns } from "./transcription-ocr-modal.vue?vue&type=template&id=5c6a6579&scoped=true&lang=pug&"
import script from "./transcription-ocr-modal.vue?vue&type=script&lang=ts&"
export * from "./transcription-ocr-modal.vue?vue&type=script&lang=ts&"
import style0 from "./transcription-ocr-modal.vue?vue&type=style&index=0&id=5c6a6579&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a6579",
  null
  
)

export default component.exports